import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';
import { IPrinterConfigurations } from '../../Interfaces/IPrinterConfigurations';
import { IBuildings } from '../../Interfaces/IBuildings';
import { ITypesLabelsPrinter } from '../../Interfaces/ITypesLabelsPrinter';
import { BuildingsService } from '../../services/buildings-services';
import { TransactionResult } from 'src/app/core/services/interfaces/transaction-result';
import { TypesLabelsPrinterService } from '../../services/typesLabelsPrinter-services';
import { PrinterConfigurationsService } from '../../services/printerconfigurations-service';
declare var jQuery: any;
@Component({
  selector: 'printer-configurations-detail',
  templateUrl: './printer-configurations-detail.component.html',
  styles: []
})
export class PrinterConfigurationsDetailComponent implements OnInit {

  formGroup: FormGroup;
  loading = false;
  listBuildings: Array<IBuildings> = [];
  listTypesLabel: Array<ITypesLabelsPrinter> = [];
  
  constructor(
    private dialogRef: MatDialogRef<PrinterConfigurationsDetailComponent>,
		@Inject(MAT_DIALOG_DATA) public data: IPrinterConfigurations,
		private notificationService: NotificationService,
    public translate: TranslateApplicationService,
    private formBuilder: FormBuilder,
    private buildingsService: BuildingsService,
    private typesLabelsPrinterService: TypesLabelsPrinterService,
    private printerConfigurationsService: PrinterConfigurationsService
  ) {
    this.formGroup = this.formBuilder.group({
      pkprinterconfiguration: [data.pkprinterconfiguration == null? 0 : data.pkprinterconfiguration],
      txtlabelpath: [
        data.labelpath == null ? "" : data.labelpath,
        [Validators.required, Validators.pattern('^[\\\\][^ ]+$')]
      ],
      txtprinterpath: [
        data.printerpath == null ? "" : data.printerpath,
        [Validators.required, Validators.pattern('^[\\\\][^ ]+$')]
      ],
      txtlabelquantity: [
        data.labelquantity == null ? "" : data.labelquantity,
        [Validators.required, Validators.pattern('^[1-9][0-9]*$')]
      ],
      txtprinternumber: [
        data.printernumber == null ? "" : data.printernumber,
        [Validators.required, Validators.pattern('^[1-9][0-9]*$')]
      ],
      cbfkbuilding: [data.fkbuilding, Validators.required],
      cbfktypelabelprinter: [data.fktypelabelprinter, Validators.required],
      fkemployeecreator: [data.fkemployeecreator]
    });
  }

  ngOnInit(): void {
    this.GetBuildings();
    this.GetTypesLabelsPrinter();
  }

  GetBuildings() {
    this.loading = true;
    this.buildingsService.GetAvailableBuildings().subscribe(
      (result: TransactionResult<IBuildings[]>) => {
        this.loading = false;
        if (result.success) {
          this.listBuildings = result.data;
        }
        else{
          this.ErrorAlert(result.message);
        }
      },
      (error) => {
        this.ErrorAlert(error);
        this.loading = false;
      }
    );
  }

  GetTypesLabelsPrinter() {
    this.loading = true;
    this.typesLabelsPrinterService.GetTypesLabelsPrinter().subscribe(
      (result: TransactionResult<ITypesLabelsPrinter[]>) => {
        this.loading = false;
        if (result.success) {
          this.listTypesLabel = result.data;
        }
        else{
          this.ErrorAlert(result.message);
        }
      },
      (error) => {
        this.ErrorAlert(error);
        this.loading = true;
      }
    );
  }

  SelectBuilding(event:any)
  {
    this.loading = true;
    jQuery('.ng-select .ng-select-container').css('max-width', '182px');
    this.loading = false;
  }

  Save() {
    this.loading = true;
    if (this.formGroup.valid) {
      if (this.formGroup.controls.pkprinterconfiguration.value == 0) {
        this.printerConfigurationsService.CreatePrinterConfiguration(this.formGroup.value).subscribe(
          (result: TransactionResult<boolean>) => {
            this.loading = false;
            if (result.success) {
              this.Alert("Success", this.translate.TranslateKey('COMPLETE'));
              this.Close();
            }
          },
          (error) => {
            this.ErrorAlert(error);
            this.loading = false;
          }
        );
      } else {
        this.printerConfigurationsService.UpdatePrinterConfiguration(this.formGroup.value).subscribe(
          (result: TransactionResult<boolean>) => {
            this.loading = false;
            if (result.success) {
              this.Alert("Success", this.translate.TranslateKey('COMPLETE'));
              this.Close();
            }
          },
          (error) => {
            this.ErrorAlert(error);
            this.loading = false;
          }
        );
      }
    } else {
      this.loading = false;
      this.Alert("Warning", "WARNINGS.Empty_fields");
   }
  }

  Close() {
    this.dialogRef.close(true);
  }

  Alert(title: string, message: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: this.translate.TranslateKey(message),
			shown: true,
		});
	}

  ErrorAlert(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: message,
			shown: true,
		});
 	}
}
